import AddNewProduct from "./AddNewProduct";
import AddNewProductType from "./AddNewProductType";
import Products from "./Products";

export default { AddNewProduct, AddNewProductType, Products };
